import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy" style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', color: "whitesmoke", backgroundColor: 'black', minHeight: "100vh" }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: 4.27.2025</p>
      
      <p>
        This Privacy Policy describes our policies and procedures on the collection, use, and disclosure
        of your information when you use our app.
      </p>

      <h2>Information Collection and Use</h2>
      <p>
        We do not collect, use, store, or share any personal information. Your use of the app is entirely private
        and no personal data is gathered by us in any form.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. Any changes will be posted on this page.
        We recommend reviewing this Privacy Policy periodically for any updates.
      </p>
    </div>
  );
}